exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-title[data-v-18c8aa0c]{background-color:#f44336;color:#fff;width:100%}.success-title[data-v-18c8aa0c]{background-color:#4caf50;color:#fff;width:100%}.warning-title[data-v-18c8aa0c]{background-color:#ff9800;color:#000;width:100%}", ""]);

// exports
